import styled from "styled-components";

const SearchButton = styled.button`
  background: ${({ theme }) =>
    `linear-gradient(${theme.colors.main}, ${theme.colors.accent})`};
  border-radius: 0px;
  border: none;
  min-width: 50px;
  min-height: 50px;
  max-width: 50px;
  max-height: 50px;
  width: 50px;
  height: 50px;
  outline: none;
  border-radius: 100%;
  z-index: 2;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  img {
    width: 24px;
  }
`;

export default SearchButton;



// WEBPACK FOOTER //
// ./src/components/SearchButton.js